import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "picker" }
const _hoisted_2 = { class: "card mb-3 shadow-sm" }
const _hoisted_3 = { class: "card-body pb-1" }
const _hoisted_4 = { class: "card-text" }
const _hoisted_5 = { class: "intro pb-4" }
const _hoisted_6 = { class: "input-group mb-3" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_9 = { class: "col-2" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "col-10" }
const _hoisted_12 = {
  key: 0,
  class: "py-0 mb-0"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "input-group mb-3" }
const _hoisted_15 = { label: "Assets" }
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "my-3 d-flex align-items-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "Talking to the XRP Ledger...", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border ms-auto",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "alert alert-danger mb-2 mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", {
        class: _normalizeClass(["card-header", { 'text-white bg-success': 1 === 2 }])
      }, _toDisplayString(_ctx.step) + ". Select " + _toDisplayString(_ctx.accountTypeLabel), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.account) = $event)),
              type: "search",
              class: "form-control",
              placeholder: "XRP Ledger account address (r...)"
            }, null, 512), [
              [_vModelText, _ctx.account]
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary",
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.go && _ctx.go(...args)))
            }, " Go ")
          ]),
          (!_ctx.loading && _ctx.error === '' && _ctx.currencies.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_ctx.lookedUpAccount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("img", {
                          src: 'https://xumm.app/avatar/' + _ctx.account + '_150.png',
                          width: "150",
                          height: "150",
                          class: "img-fluid img-thumbnail"
                        }, null, 8, _hoisted_10)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        (_ctx.accountName !== _ctx.lookedUpAccount)
                          ? (_openBlock(), _createElementBlock("h4", _hoisted_12, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.accountName), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("code", null, _toDisplayString(_ctx.lookedUpAccount), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDestination)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("h5", null, " Pick currency & amount to " + _toDisplayString(_ctx.isDestination ? "deliver" : "send") + ": ", 1),
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("select", {
                          class: "input form-control",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCurrency) = $event))
                        }, [
                          _createElementVNode("optgroup", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencies, (currency) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: currency.code,
                                key: currency.code
                              }, _toDisplayString(currency.label), 9, _hoisted_16))
                            }), 128))
                          ])
                        ], 512), [
                          [_vModelSelect, _ctx.selectedCurrency]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          class: "input form-control",
                          type: "text",
                          placeholder: "Amount (selected asset)",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.amount) = $event))
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.amount,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
          : _createCommentVNode("", true),
        (!_ctx.loading && _ctx.error !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}